<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">
        <div class="row mb-4">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Lista de Vendedores</h1>
                        <p class="welcome-message">Gerenciamento de Vendedores</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 header-actions">

                <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
                    @if(selection.hasValue()) {
                    <span>Ações ({{selection.selected.length}})</span>
                    } @else {
                    <span>Ações</span>
                    }
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>

                <mat-menu #opcoesMenu="matMenu">
                    <span class="menu-action-tooltip-wrapper" [matTooltip]="getTooltipAlterarResponsavelSemSelecao()"
                        [matTooltipDisabled]="selection.hasValue()" matTooltipPosition="above">
                        <button mat-menu-item (click)="abrirModalAlterarResponsavelEmMassa()"
                            [disabled]="!selection.hasValue()">
                            <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
                            <span>Alterar vendedor responsável</span>
                        </button>
                    </span>
                    <span class="menu-action-tooltip-wrapper" [matTooltip]="getTooltipExcluirSemSelecao()"
                        [matTooltipDisabled]="selection.hasValue()">
                        <button mat-menu-item (click)="abrirModalExcluir()" [disabled]="!selection.hasValue()">
                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                            <span>Excluir selecionados</span>
                        </button>
                    </span>
                </mat-menu>

                <button type="button" mat-flat-button class="btn-primary" routerLink="/cadastros/vendedor/cadastrar">
                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                    Novo Vendedor
                </button>
            </div>
        </div>

        <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
            <div class="row search-area">
                <div class="col-md-6">
                    <div class="search-wrapper">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Pesquisar por nome...</mat-label>
                            <input matInput type="text" formControlName="pesquisa" placeholder="Ex: João Silva">

                            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                                <mat-icon>search</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </div>
            </div>

        </form>

        @if(_listaVendedorResponse && _dataSource.data.length > 0) {

        <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="w-checkbox">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome </th>
                <td mat-cell *matCellDef="let element">
                    <div class="nome-cell">
                        <span>{{element.vendedor.nome}}</span>
                        @if (element.qtdSubordinadosDiretos > 0) {
                        <button type="button" class="chip-subordinados" title="Ver hierarquia"
                            (click)="$event.stopPropagation(); abrirHierarquia(element.vendedor.idVendedor)">
                            <mat-icon class="material-symbols-outlined">account_tree</mat-icon>{{
                            element.qtdSubordinadosDiretos }}
                        </button>
                        }
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="vendedorResponsavel">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Vendedor Responsável </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.nomeVendedorResponsavel || '—' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="cidade">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Município </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.cidade }}
                </td>
            </ng-container>

            <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> UF </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.uf }}
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                <td mat-cell *matCellDef="let element">
                    <span class="status-badge badge-dot"
                        [ngClass]="getStatusClass(element.vendedor.idSituacaoVendedor)">
                        {{ getStatusLabel(element.vendedor.idSituacaoVendedor) }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                <td mat-cell *matCellDef="let element" class="text-center w-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/cadastros/vendedor/cadastrar', {idVendedor: element.vendedor.idVendedor}]">
                            <span class="material-symbols-outlined">edit</span>
                            <span>Editar</span>
                        </button>
                        <button mat-menu-item (click)="abrirHierarquia(element.vendedor.idVendedor)">
                            <span class="material-symbols-outlined">account_tree</span>
                            <span>Ver hierarquia</span>
                        </button>
                        <button mat-menu-item (click)="abrirModalExcluir(element)">
                            <span class="material-symbols-outlined">delete</span>
                            <span>Excluir</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>
        </table>


        <div class="mobile-view">
            @for (vendedorStruct of _dataSource.data; track vendedorStruct.vendedor.idVendedor) {
            <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(vendedorStruct)">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        <mat-checkbox (change)="$event ? selection.toggle(vendedorStruct) : null"
                            [checked]="selection.isSelected(vendedorStruct)">
                        </mat-checkbox>
                        <span class="text-bold">{{vendedorStruct.vendedor.nome}}</span>
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="menuMobile">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/cadastros/vendedor/cadastrar', {idVendedor: vendedorStruct.vendedor.idVendedor}]">Editar</button>
                        <button mat-menu-item (click)="abrirHierarquia(vendedorStruct.vendedor.idVendedor)">Ver
                            hierarquia</button>
                        <button mat-menu-item (click)="abrirModalExcluir(vendedorStruct)">Excluir</button>
                    </mat-menu>
                </div>
                <div class="card-body-mobile p-3">
                    <p class="mb-1"><small>Vendedor Responsável:</small> {{vendedorStruct.nomeVendedorResponsavel ||
                        '—'}}</p>
                    @if (vendedorStruct.qtdSubordinadosDiretos > 0) {
                    <p class="mb-1">
                        <small>Subordinados diretos:</small>
                        <button type="button" class="chip-subordinados" title="Ver hierarquia"
                            (click)="$event.stopPropagation(); abrirHierarquia(vendedorStruct.vendedor.idVendedor)">
                            <mat-icon class="material-symbols-outlined">account_tree</mat-icon>{{
                            vendedorStruct.qtdSubordinadosDiretos }}
                        </button>
                    </p>
                    }
                    <p class="mb-1"><small>Município/UF:</small> {{vendedorStruct.cidade}} - {{vendedorStruct.uf}}</p>
                    <span class="status-badge badge-dot"
                        [ngClass]="getStatusClass(vendedorStruct.vendedor.idSituacaoVendedor)">
                        {{ getStatusLabel(vendedorStruct.vendedor.idSituacaoVendedor) }}
                    </span>
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center mt-4 mb-5">
            <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading === true) {
                <mat-spinner [diameter]="20"></mat-spinner>
                }
                @else {
                <span class="material-symbols-outlined">expand_more</span>
                Ver Mais
                }
            </button>
        </div>

        } @else if(_isLoading === true && _dataSource.data.length === 0) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else {
        <app-empty-list [title]="'Nenhum vendedor encontrado'"
            [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
        }
    </div>
</div>